<template>
  <div class="Model">
    <Modal
      v-model="registerStatus"
      title="注册节点"
      :closable="false"
      :mask-closable="false"
      :footer-hide="true"
    >
     <ul v-if="regiseterObj">
       <li>执行器AppName：{{ regiseterObj.appName }}</li>
       <li>执行器名称：{{ regiseterObj.title }}</li>
     </ul>
     <p v-else>暂无数据</p>
    <!-- 按钮组 -->
    <div class="btn-box">
      <Button class="ys-confirm" type="primary" @click="ok" style="width: 100px;">确认</Button>
    </div>
    </Modal>
  </div>
</template>
<script>
export default {
  props:{
    registerStatus: {
      type: Boolean,
      default: false
    },
    regiseterObj: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
    }
  },
  methods:{
    ok (name) {
      this.$emit('handle-register-model', {code: 2})
    }
  },
  mounted() {
    
  }
}
</script>
<style lang="less" scoped>
.btn-box {
  width: 100%;
  display: flex;
  flex-wrap: nowrap;
  justify-content: flex-end;
  margin-top: 40px;
}
</style>